<template>
  <div>
    <div class="accountMain">
      <el-tabs type="border-card" v-model="activeName" @tab-click="changetab">
        <el-tab-pane label="订单流水" name="assembly">
          <div class="dFlex">
            <div class="colorRed">
              <div class="fz16">收入</div>
              <div class="fz16">{{ format_number(totalRevenue) }}元</div>
            </div>
            <div class="colorGreen">
              <div class="fz16">支出</div>
              <div class="fz16">{{ format_number(totalExpenses) }}元</div>
            </div>
            <div class="colorBlack">
              <div class="fz16">合计</div>
              <div class="fz16">{{ format_number(cashSurplus) }}元</div>
            </div>
          </div>
          <el-form :inline="true" :model="accountFrom">
            <el-form-item>
              <el-date-picker
                v-model="accountFrom.dateStart"
                type="date"
                placeholder="选择开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
              >
              </el-date-picker>
              至
              <el-date-picker
                v-model="accountFrom.dateEnd"
                type="date"
                placeholder="选择结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select
                filterable
                clearable
                v-model="accountFrom.shopId"
                size="small"
                placeholder="门店筛选"
                :disabled="showshopId"
                @change="shopIdChange"
              >
                <el-option
                  v-for="item in this.mdSelectList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                clearable
                size="small"
                v-model="accountFrom.queryData"
                placeholder="订单编号/姓名/电话/备注"
                @input="queryDataChange"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="accountSearch" size="small">
                搜索
              </el-button>
              <el-button
                type="primary"
                @click="accountSearchClear"
                size="small"
              >
                清空
              </el-button> 
            </el-form-item>-->
          </el-form>
          <div class="flex">
            <div></div>
            <el-button
              size="small"
              type="primary"
              class="btnClass"
              @click="copyOut"
            >
              导出
            </el-button>
          </div>
          <el-table :data="accountData" v-loading="loading">
            <el-table-column
              prop="dateStr"
              label="日期"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="timeStr"
              label="时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="orderNumber" label="订单编号" align="center">
              <template slot-scope="scope">
                <div class="colorBlue" @click="openOrderDetails(scope.row)">
                  {{ scope.row.orderNumber }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="memberName" label="会员姓名" align="center">
            </el-table-column>
            <el-table-column
              prop="memberMobile"
              label="会员电话"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="actualAmount"
              label="金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                {{ format_number(scope.row.actualAmount) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="payMethod"
              label="交易方式"
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="shopName" label="门店/部门" align="center">
            </el-table-column>
            <el-table-column prop="remarks" label="备注" align="center">
            </el-table-column>
          </el-table>
          <el-pagination
            class="pageClass"
            @size-change="SizeChange"
            @current-change="otCurrentChange"
            layout="total,prev, pager,next,sizes"
            :current-page.sync="otResult.current"
            :page-size="otResult.size"
            :total="otResult.total"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="收支统计" name="assemblyStorage"> </el-tab-pane>
        <el-tab-pane label="教练统计" name="coachStatistics"> </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 订单详情 -->
    <orderOverDetails
      v-model="orderDetails"
      :orderId="orderId"
    ></orderOverDetails>
    <!-- <el-dialog
      title="订单详情"
      :visible.sync="orderDetails"
      width="25%"
      :before-close="orderDetailsClose"
      :close-on-click-modal="false"
    >
      <div class="box">
        <div class="dialogClass">
          <div class="underline">
            <div class="lableWidth">会员</div>
            <div>{{ detail.memberName }}-{{ detail.memberMobile }}</div>
          </div>
          <div class="underline">
            <div class="lableWidth">收款时间</div>
            <div>
              {{ detail.collectionTime }}&nbsp; &nbsp;
            </div>
          </div>
          <div>
            <div class="lableWidth">交易方式</div>
            <div class="rest_width">{{ detail.payMethod }}</div>
          </div>
          <div class="listBackground">费用明细</div>
          <div v-for="item in detail.antOrderMiscellaneousList" :key="item.id">
            <div class="lableWidth">{{ item.name }}</div>
            <div>{{ item.money }}</div>
          </div>
          <div class="all">
            <div class="lableWidth">合计</div>
            <div>{{ detail.totalMoney }}</div>
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  getFlowTypeStatistics,
  getFlowTypeStatisticsForExcel,
} from "@/api/standingBookManagement.js";
import { getAntDeptSelect } from "../../api/BusinessManagement";
import orderOverDetails from "../components/orderOverDetails.vue";
import { dateNowYear } from "../../utils/util";

export default {
  name: "AccountManagement",
  components: {
    orderOverDetails,
  },
  data() {
    return {
      activeName: "assembly",
      mdSelectList: [],
      totalRevenue: "",
      totalExpenses: "",
      cashSurplus: "",
      accountFrom: {
        dateStart: dateNowYear(),
        dateEnd: dateNowYear(),
        shopId: "",
        queryData: "",
        pageNo: 1,
        pageSize: 10,
      },
      accountData: [],
      orderDetails: false,
      // detail: {},
      otResult: {},
      showshopId: false,
      orderId: "",
      loading: false,
    };
  },
  created() {
    this.accountFrom.shopId = this.$route.query.shopId;
  },
  mounted() {
    this.getFlowTypeStatistics(this.accountFrom);
    this.getAntDeptSelect();
    this.isStoreManager();
  },
  methods: {
    changetab(tab) {
      if (tab.label == "收支统计") {
        this.$router.push({
          path: "/AccountManagement/assemblyStorage",
          query: { shopId: this.accountFrom.shopId },
        });
      } else if (tab.label == "教练统计") {
        this.$router.push({
          path: "/AccountManagement/coachStatistics",
          query: { shopId: this.accountFrom.shopId },
        });
      }
    },
    // 搜索
    // accountSearch() {
    //   if (
    //     this.accountFrom.dateStart &&
    //     this.accountFrom.dateEnd &&
    //     new Date(this.accountFrom.dateStart).getTime() >
    //       new Date(this.accountFrom.dateEnd).getTime()
    //   ) {
    //     this.$message.error("开始时间不能大于结束时间");
    //     return;
    //   }
    //   this.getFlowTypeStatistics(this.accountFrom);
    // },
    // 清空
    // accountSearchClear() {
    //   this.accountFrom = {
    //     dateStart: "",
    //     dateEnd: "",
    //     shopId: "",
    //     queryData: "",
    //     pageNo: 1,
    //     pageSize: 10,
    //   };
    //   this.getFlowTypeStatistics(this.accountFrom);
    // },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无门店数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 流水列表
    getFlowTypeStatistics(params) {
      this.loading = true;
      getFlowTypeStatistics(params).then((res) => {
        // console.log(res);
        this.loading = false;
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无流水数据",
            });
          } else {
            this.accountData = res.data.result.orderList.records;
            this.totalRevenue = res.data.result.totalRevenue;
            this.totalExpenses = res.data.result.totalExpenses;
            this.cashSurplus = res.data.result.cashSurplus;
            this.otResult = res.data.result.orderList;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    dateChange() {
      // console.log(this.accountFrom.dateStart);
      // console.log(new Date(this.accountFrom.dateStart).getTime());
      // console.log(this.accountFrom.dateEnd);
      // console.log(new Date(this.accountFrom.dateEnd).getTime());
      // if (
      //   this.accountFrom.dateStart &&
      //   this.accountFrom.dateEnd &&
      //   new Date(this.accountFrom.dateStart).getTime() >
      //     new Date(this.accountFrom.dateEnd).getTime()
      // ) {
      //   this.$message.error("开始时间不能大于结束时间");
      //   return;
      // }
      this.accountFrom.pageNo = 1;
      this.getFlowTypeStatistics(this.accountFrom);
    },
    shopIdChange() {
      this.accountFrom.pageNo = 1;
      this.getFlowTypeStatistics(this.accountFrom);
    },
    queryDataChange() {
      this.accountFrom.pageNo = 1;
      this.getFlowTypeStatistics(this.accountFrom);
    },
    SizeChange(newSize) {
      this.$set(this.accountFrom, "pageSize", newSize);
      this.getFlowTypeStatistics(this.accountFrom);
    },
    otCurrentChange(newPage) {
      this.$set(this.accountFrom, "pageNo", newPage);
      this.getFlowTypeStatistics(this.accountFrom);
    },
    openOrderDetails(row) {
      this.orderDetails = true;
      this.orderId = row.orderId;
    },
    orderDetailsClose() {
      this.orderDetails = false;
    },
    // 导出
    copyOut() {
      getFlowTypeStatisticsForExcel(this.accountFrom).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "订单流水";
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
    //如果是店长账号 只能看见自己门店的台账
    isStoreManager() {
      if (sessionStorage.roleCode === "storeManager") {
        this.accountFrom.shopId = sessionStorage.shopId;
        this.showshopId = true;
      }
    },
    format_number(nStr) {
      nStr += ""; //数字转换为字符
      let x = nStr.split("."); //按照小数点分隔
      let x1 = x[0]; //整数部分
      let x2 = x.length > 1 ? "." + x[1] : ""; //小数部分
      let rgx = /(\d+)(\d{3})/; //正则式定义
      while (rgx.test(x1)) {
        //正则式匹配
        x1 = x1.replace(rgx, "$1" + "," + "$2"); //正则式替换
      }
      return x1 + x2;
    },
  },
};
</script>

<style scoped>
.colorBlue {
  color: #409eff;
}
.colorRed {
  color: red;
}
.colorGreen {
  color: rgb(48, 162, 87);
}
.colorBlack {
  color: Black;
}
.fz16 {
  font-size: 16px;
  font-weight: 700;
}
.accountMain {
  padding: 30px;
}
.dFlex {
  display: flex;
}
.dFlex > div {
  width: 100px;
  text-align: center;
  margin-bottom: 20px;
}
.box {
  padding-top: 10px;
  padding-bottom: 50px;
}
.dialogClass {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.dialogClass > div {
  padding: 10px 20px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  display: flex;
  align-content: space-between;
}
.underline {
  border-bottom: 1px solid #ccc;
}
.rest_width {
  width: calc(100% - 100px);
}
.lableWidth {
  width: 100px;
}
.listBackground {
  background: rgb(215, 215, 215);
}
.all {
  background: rgb(242, 242, 242);
}
.pageClass {
  margin: 30px 10px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.btnClass {
  margin-right: 20px;
  margin-bottom: 10px;
}
</style>
